import { Image } from 'foundations-components/transitional/components/Image';

// @ts-expect-error svg import
import ServiceHubSvg from 'bender-url!./images/ServiceHub.svg';
import { MERCH_CARD_PRODUCT_ICON_STYLE_PROPS, PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS } from './styleProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ServiceHubProductIcon = ({
  useCase = 'productPageTitle'
}) => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: ServiceHubSvg
  }, useCase === 'productPageTitle' ? PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS : MERCH_CARD_PRODUCT_ICON_STYLE_PROPS));
};